// extracted by mini-css-extract-plugin
export var numpadContainer = "_r4-1";
export var phoneButton = "_r4-0";